const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const Element = require('../model/element.base')
const InputAttributes = require('./input_attributes')

const log = require('log').create('freeform', 'input_view') // eslint-disable-line


/* parent input view, meant to be subclassed for specific input types */

const InputView = Marionette.View.extend({

    displayName: 'InputView',

    tagName: 'input',

    template: _.template(''),

    events: {
        'blur': 'onBlur',
        'focus': 'onFocus',
    },

     
    constructor: function constructor() {
        Marionette.View.apply(this, arguments)

        // validate model
        if (! (this.model instanceof Element)) throw new Error('InputView requires an Element model.')

        // listen for external changes to the model
        this.listenTo(this.model, 'change:value', this.onModelChangeValue)

        // these steps allow the view to consume an existing dom element
        this.listenTo(this, 'render', this.setAttributes)
        const className = this.model.get('className')
        if (className) this.$el.addClass(className)

        this.listenTo(this.model, 'change:placeholder', (model, placeholder) => {
            this.$el.attr('placeholder', placeholder)
        })
        this.listenTo(this.model, 'change:disabled', (model, disabled) => {
            this.$el.attr('disabled', disabled)
        })

        // listen for focus event on the model
        this.listenTo(this.model, 'request:focus', this.focus)
    },

    triggers: {
        'change': 'input:change',
    },

    onInputChange() {
        const value = this.getInputValue()
        this.model.set('value', value, { from: this })
    },

    getInputValue() {
        return this.$el.val()
    },
    setInputValue(value) {
        this.$el.val(value)
    },

    // when focus is requested
    focus() {
        this.$el.focus()
    },

    // when focused/blurred naturally
    onBlur() {
        this.model.trigger('blur')
    },

    onFocus() {
        this.model.trigger('focus')
    },

    onModelChangeValue(model, value, options) {
        if (options.from !== this) {
            this.setInputValue(value)
        }
    },

})

// apply methods from InputAttributes mixin
_.extend(InputView.prototype, InputAttributes)

module.exports = InputView
